export function isReferralConfirmable(status: string) {
  return status !== 'confirmed' && status !== 'closed';
}

export function isReferralClosable(status: string) {
  return status !== 'closed';
}
